import {
    ConditionType_DaterangeFixedIncludes,
    ConditionType_DaterangeFixedOverlaps,
    ConditionType_DaterangeFixedWithin,
    ConditionType_DaterangeRelativeIncludes,
    ConditionType_DaterangeRelativeOverlaps,
    ConditionType_DaterangeRelativeWithin,
    ConditionType_IsNull,
    ConditionType_NotNull
} from "../../model2/conditions/condition-types";


export const FIELD_CONDITIONS_DATERANGE = [

    ConditionType_NotNull,
    ConditionType_IsNull,

    ConditionType_DaterangeFixedIncludes,
    ConditionType_DaterangeFixedOverlaps,
    ConditionType_DaterangeFixedWithin,

    ConditionType_DaterangeRelativeIncludes,
    ConditionType_DaterangeRelativeOverlaps,
    ConditionType_DaterangeRelativeWithin,

]